// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-enter[data-v-67ee0ee0]{opacity:0}.fade-enter-active[data-v-67ee0ee0],.fade-leave-active[data-v-67ee0ee0]{transition:opacity .25s ease}.fade-leave-active[data-v-67ee0ee0]{opacity:0}.v-application--is-ltr[data-v-67ee0ee0] .v-data-footer__select{margin-left:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
